
exports.install = function (Vue, options) {
    // toast
    Vue.prototype.$toast = function(toastText) {
        Vue.$vux.toast.show({
            type: 'text',
            time: 3000,
            position: 'middle',
            text: toastText
        })
    };
    // loading
    Vue.prototype.$loading = {
        show: function(loadingText) {
            Vue.$vux.loading.show({
                text: loadingText
            })
        },
        hide: function() {
            Vue.$vux.loading.hide()
        }
    }
    // confirm  
    Vue.prototype.$confirm = {
        show: function(configObj) {
            Vue.$vux.confirm.show({
                title: configObj.title || '提示',
                content: configObj.content,
                onCancel: configObj.onCancel,
                onConfirm: configObj.onConfirm,
            })
        },
        hide: function() {
            Vue.$vux.confirm.hide()
        }
    }
    //confirm 弹窗 2秒后自动关闭
    Vue.prototype.$showConfirm = function(confirmText) {
        Vue.$vux.confirm.show({
            title: '提示',
            content: confirmText,
            showCancelButton: false
        })
    }
    Vue.prototype.$confirmAuto = function(confirmText) {
        Vue.prototype.$showConfirm(confirmText)
        setTimeout(() => {
            Vue.$vux.confirm.hide()
        }, 2000)
    }
    //alert 弹窗 2秒后自动关闭  有兼容性问题，暂时用confirm代替alert
    Vue.prototype.$showAlert = function(alertText) {
        Vue.$vux.alert.show({
            title: '提示',
            content: alertText
        })
    }
    Vue.prototype.$alert = function(alertText) {
        Vue.prototype.$showAlert(alertText)
        setTimeout(() => {
            Vue.$vux.alert.hide()
        }, 2000)
    }
    
};


// WEBPACK FOOTER //
// ./src/public/vuxEncapue.js